import { useState } from "react";
import { initiateCheckout } from "../services/api";

const AWARD_CATEGORIES = [
  "Best Course Rep",
  "Freshest Fresher",
  "Most Popular Student",
  "Best Entrepreneur",
  "Best Dressed Male",
  "Best Dressed Female",
  "Best Entertainer",
  "Most Influential Department President",
  "Best Department",
  "Most Influential Person",
  "Best Dressed Student During Faculty Week",
  "Most Dedicated Student",
  "Best Final Year Student",
  "Personality of the Year (Male)",
  "Personality of the Year (Female)",
];

const initialForm = {
  full_name: "",
  award_category: "",
  email: "",
  amount: "",
  contestant_number: "",
};

export const useCheckout = () => {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [serverError, setServerError] = useState(null);

  const validate = () => {
    const newErrors = {};
    if (!form.full_name || form.full_name.trim().length < 2)
      newErrors.full_name = "Enter your full name";
    if (!form.award_category) newErrors.award_category = "Please select an award category";
    if (!form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      newErrors.email = "Enter a valid email address";
    if (!form.amount || isNaN(form.amount) || Number(form.amount) <= 0)
      newErrors.amount = "Enter a valid amount";
    if (!form.contestant_number)
      newErrors.contestant_number = "Contestant number is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
    setServerError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setServerError(null);

    try {
      const metadata = {
        award_category: form.award_category,
        contestant_number: form.contestant_number,
        submitted_at: new Date().toISOString(),
        user_agent: navigator.userAgent,
        platform: navigator.platform,
      };

      const payload = {
        full_name: form.full_name.trim(),
        award_category: form.award_category,
        email: form.email,
        amount: Number(form.amount),
        contestant_number: form.contestant_number,
        ...metadata,
      };

      const { payment_link } = await initiateCheckout(payload);
      window.location.href = payment_link;
    } catch (err) {
      setServerError(err.message || "Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  return {
    form,
    errors,
    loading,
    serverError,
    handleChange,
    handleSubmit,
    AWARD_CATEGORIES,
  };
};